export const AUTHORIZATION_BEARER_TOKEN_PREFIX = 'Bearer ';
export const USER_LIVE_CHANNEL = '/user/queue/specific-user-user';
export const MAX_FILE_UPLOAD_SIZE = 31457280; // 30 MiB
export const MAX_TEMPLATE_UPLOAD_SIZE = 5242880; // 5 MiB
export const PASSWORD_STRENGTH_REGEX = '^.*(?=.{8,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).*$';
export const PDF_FILE_EXTENSION = 'pdf';
export const DOCX_FILE_EXTENSION = 'docx';
export const PDF_FILE_MIME_TYPES = ['application/pdf'];
export const DOCX_FILE_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12'
];
export const SUPPORTED_PREVIEW_MIME_TYPE = PDF_FILE_MIME_TYPES.concat(DOCX_FILE_MIME_TYPES);
export const EVICTION_REASONS_CLAIMS_MAP = new Map<string, boolean>([
  ['Unpaid Rent', true],
  ['Criminal Willful Conduct', true],
  ['Holdover Tenancy', true],
  ['Material Non-Compliance', true],
  ['Foreclosure', true],
  ['Other', true]
]);

/**
 * Default File Naming Standard for a new document template. Matter first, then document type, then an
 * ISO date — the convention court e-filing standards and legal document management tooling expect.
 * Keep in sync with `Form.DEFAULT_FILE_NAME_PATTERN` on the backend, which applies the same fallback
 * server-side for templates that carry no pattern.
 */
export const DEFAULT_FILE_NAME_PATTERN = '#case_id#_#type#_#current_date#';

/**
 * Naming standard applied to an upload when the org has configured none (EE-349). Deliberately the
 * uploaded name itself, so deploying the feature renames nobody's files. Keep in sync with
 * `Constants.DEFAULT_UPLOAD_FILE_NAME_PATTERN` on the backend.
 */
export const DEFAULT_UPLOAD_FILE_NAME_PATTERN = '#original_file_name#';
